//获取url地址上参数对象
export function parseUrlParam(url) {
  if (!url) {
    url = window.location.href;
  }
  var urlParam = {};
  if (url.indexOf("?") < 0) {
    return urlParam;
  }
  var params = url.substring(url.indexOf("?") + 1).split("&");
  for (var i = 0; i < params.length; i++) {
    var k = params[i].substring(0, params[i].indexOf("="));
    var v = params[i].substring(params[i].indexOf("=") + 1);
    if (v.indexOf("#") > 0) {
      v = v.substring(0, v.indexOf("#"));
    }
    urlParam[k] = v;
  }
  return urlParam;
}
export function getPwdScore(pwd) {
  let score = 0;
  if (!pwd) {
    return score;
  } else {
    let size = pwd.length;
    if (size < 7) {
      score += 5;
    } else if (size >= 7 && size <= 9) {
      score += 10;
    } else {
      score += 20;
    }
    let numCount = 0,
      lowerCount = 0,
      upperCount = 0,
      specialCount = 0;
    for (let i = 0; i < size; i++) {
      let code = pwd.charCodeAt(i);
      let mode = charMode(code);
      switch (mode) {
        case 1:
          numCount++;
          break;
        case 2:
          upperCount++;
          break;
        case 3:
          lowerCount++;
          break;
        case 4:
          specialCount++;
          break;
        default:
          break;
      }
    }
    if (upperCount > 0 && lowerCount == 0) {
      score += 10;
    } else if (upperCount == 0 && lowerCount > 0) {
      score += 10;
    } else if (upperCount > 0 && lowerCount > 0) {
      score += 25;
    }
    if (numCount > 2) {
      score += 20;
    } else if (numCount > 0 && numCount <= 2) {
      score += 10;
    }
    if (specialCount == 1) {
      score += 10;
    } else if (specialCount > 1) {
      score += 25;
    }
    if (upperCount > 0 && lowerCount > 0 && numCount > 0 && specialCount > 0) {
      score += 5;
    } else if (
      (upperCount > 0 || lowerCount > 0) &&
      numCount > 0 &&
      specialCount > 0
    ) {
      score += 3;
    } else if (
      (upperCount > 0 || lowerCount > 0) &&
      numCount > 0 &&
      specialCount == 0
    ) {
      score += 2;
    }
    return score;
  }
}
export function charMode(schar) {
  if (schar >= 48 && schar <= 57) {
    //数字
    return 1;
  }
  if (schar >= 65 && schar <= 90) {
    //大写
    return 2;
  }
  if (schar >= 97 && schar <= 122) {
    //小写
    return 3;
  } else {
    //特殊符号
    return 4;
  }
}
